import styled from "styled-components";
import { breakpoints, colors } from "src/variables";

export const Container = styled.div<{
  backgroundColor?: string;
  backgroundImage?: string;
}>`
  background-color: ${(props) => props.backgroundColor || colors.white};
  position: relative;
  max-width: 1680px;
  margin: 0 auto;
  min-height: 1367px;
  box-sizing: border-box;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    // padding: 2rem 0 0 0;
    width: 100%;
    min-height: 877px;
  }
`;

export const BackgroundImage = styled.img<{
  webImageSrc: string;
  mobileImageSrc: string;
}>`
  content: url(${(props) => props.webImageSrc});
  max-width: 1680px;
  display: block;
  width: 100%;
  height: 768px;

  @media (max-width: ${breakpoints.tabletPortrait}px) {
    height: 700px;
    content: url(${(props) => props.mobileImageSrc});
  }
`;

export const JobsContainer = styled.div`
  padding: 0px 9.987rem;
  box-sizing: border-box;
  // max-width: 1380px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  font-size: 1.5rem;
  @media screen and (max-width: ${breakpoints.tabletLandscape}px) {
    padding: 0 4rem;
  }
  @media screen and (max-width: ${breakpoints.tabletPortrait}px) {
    padding: 0 2rem;
    font-size: 12px;
  }
`;

export const JobsCount = styled.p`
  font-family: "TeleNeo";
  font-weight: 700;
  width: 100%;
  text-align: left;
  margin: 1rem auto;
  color: ${colors.white};
`;

//Table styles

export const TableContainerBox = styled.div`
  flex-direction: column;
  display: flex;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.25) 0px 4px 24px 0px;
  margin: 2rem 0;
  border: 2px solid transparent;
  border-radius: 45px;
  background-color: rgb(255, 255, 255);
  position: relative;
  padding: 68px;
  text-align: left;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    box-sizing: border-box;
    border-width: 0.5px;
    box-shadow: 0px 0px 24px 10px #05050524;
    border-radius: 30px;
    margin: 1rem 0px;
    padding: 0 0 32px 0;
  }
`;

export const TableHeading = styled.h3`
  color: ${colors.black};
  margin: -1rem 0 2rem;
  font-family: "TeleNeo";
  font-weight: 700;
  font-size: 44px;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    padding: 2rem 20px 0px;
    font-size: 1rem;
    margin-bottom: 0.5rem;
  }
`;

export const TableSubHeading = styled.p`
  color: ${colors.magenta};
  font-family: "TeleNeo";
  font-weight: 500;
  font-size: 28px;
  margin-bottom: 0.5rem;
  @media (max-width: ${breakpoints.tabletPortrait}px) {
    padding: 0 20px;
    font-size: 14px;
  }
`;
